import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;

// eslint-disable-next-line import/prefer-default-export
export var suggestionHeading = /*#__PURE__*/css("background-color:", colors.neutral.subdued.default, ";color:", colors.neutral.medium.default, ";", applyFont(typography.overline), " height:34px;padding:12px 23px 0;");